import { render, staticRenderFns } from "./displayRiskMonitor.vue?vue&type=template&id=2a5dacb5&scoped=true"
import script from "./displayRiskMonitor.vue?vue&type=script&lang=js"
export * from "./displayRiskMonitor.vue?vue&type=script&lang=js"
import style0 from "./displayRiskMonitor.vue?vue&type=style&index=0&id=2a5dacb5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5dacb5",
  null
  
)

export default component.exports